export const programmeBioGroups: Array<{
  category: Model.CislBio['category'];
  title: string;
}> = [
  { category: 'faculty', title: 'Faculty and Programme Team' },
  { category: 'contributors', title: 'Contributors' },
  { category: 'delegates', title: 'Delegates' },
];

export const getProgrammeBioNavigation = (
  bios: Model.CislBio[] = [],
  requestedCategory: string | null = null,
) => {
  const groups = programmeBioGroups.filter(({ category }) =>
    bios.some((bio) => bio.category === category),
  );

  return {
    groups,
    activeGroup:
      groups.find(({ category }) => category === requestedCategory) ||
      groups[0],
  };
};
